<template>
    <div class="row ml-xl-4 m-0">
        <div class="col-12">
            <h3>Transacciones:</h3>
        </div>
        <div class="col-12 table-responsive scroll-table">
            <table class="table table-hover text-nowrap">
                <thead>
                    <tr>
                        <th class="text-center">Nº de pedido</th>
                        <th class="text-center">Importe</th>
                        <th class="text-center">Descuento aplicado</th>
                        <th class="class-center">Descuento monedero</th>
                        <th class="text-center">Importe sin descuento</th>
                        <th class="text-center">Método de pago</th>
                        <th class="text-center">Fecha</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(transaccion, index) in transacciones">
                        <tr :key="index">
                            <td class="text-center">{{ transaccion.tpv_order ? transaccion.tpv_order : transaccion.n_pedido }}</td>
                            <td class="text-center">{{ transaccion.importe | formatear_precio }}</td>
                            <td class="text-center">
                                <template v-if="transaccion.descuento_integro">
                                    {{ transaccion.descuento_integro | formatear_precio }}
                                </template>
                                <template v-else-if="transaccion.descuento_aplicado">
                                    {{ transaccion.descuento_aplicado }} %
                                </template>
                            </td>
                            <td class="text-center">
                                <template v-if="transaccion.descuento_monedero">
                                    {{ transaccion.descuento_monedero | formatear_precio }}
                                </template>
                            </td>
                            <td class="text-center" v-if="transaccion.importe_sin_descuento">{{ parseInt(transaccion.importe_sin_descuento) | formatear_precio }}</td>
                            <td v-else></td>
                            <td class="text-center">{{ transaccion.metodo_pago | formatear_metodo_pago }}</td>
                            <td class="text-center">
                                {{ transaccion.fecha }}
                            </td>
                            <td>
                                <Button 
                                    v-if="transaccion.metodo_pago != 5"
                                    icon="fa fa-pen"
                                    @click="$modal.show('editTransaccion-' + transaccion.id);"
                                />
                                <EditarTransaccion :transaccion="transaccion" :params="params" :ruta="ruta" @cerrar="cerrarModal" />
                            </td>
                        </tr>
                    </template>
                    <tr>
                        <td class="text-right" style="font-size: 15px">
                            <b>Balance:</b>
                        </td>
                        <td colspan="7" style="font-size: 15px">
                            <b>{{ total | formatear_precio }}</b>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import EditarTransaccion from "./EditarTransaccion";

    export default {
        props: {
            transacciones: Array,
            params: Object,
            ruta: String
        },
        methods: {
            cerrarModal(modal, actualizar) {
                this.$modal.hide(modal);
                if(actualizar) {
                    this.$emit('actualizar');
                }
            },
        },
        computed : {
            total() {
                let total = 0;
                this.transacciones.forEach(transaccion => {
                    total += transaccion.importe;
                });
                return total;
            }
        },
        components: {
            EditarTransaccion
        }
    }
</script>